module.exports = __webpack_public_path__ + "img/14.adeaa174.jpg";